export default __webpack_public_path__ + "static/media/GAN4.2d86396c.png";